/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

@Component({
  standalone: false,
  selector: 'adn-creative-dims-output',
  template: `
    <div *ngIf="creative?.dimensionType === 'FIXED'">
      <span *ngIf="!creative?.width && !creative?.height">-</span>
      <span *ngIf="creative?.width || creative?.height">{{ creative?.width || '--' }}&times;{{ creative?.height || '--' }}</span>
    </div>
    <div *ngIf="creative?.dimensionType === 'FIXED_WIDTH'">
      {{ creative?.width || '--' }}px width
    </div>
    <div *ngIf="creative?.dimensionType === 'FIXED_HEIGHT'">
      {{ creative?.height || '--' }}px height
    </div>
    <div *ngIf="creative?.dimensionType === 'FLEXIBLE'">
      Flexible
    </div>
  `
})
export class CreativeDimsOutputComponent {
  @Input() creative: any;
}
